export default "__VITE_ASSET__addd6987__"